import * as yup from "yup";

export const onboardingSchema = yup.object({
  splash: yup.object({
    s_title: yup
      .string()
      .trim()
      .required("Title is required")
      .max(150, "Title must be at most 150 characters"),

    s_subTitle: yup
      .string()
      .trim()
      .required("Sub Title is required")
      .max(150, "Sub Title must be at most 150 characters"),
  }),

  auth: yup.object({
    a_image: yup
      .mixed<File | string | null>()
      .nullable()
      .test(
        "fileType",
        "Only JPG / PNG images are allowed",
        (value) =>
          !value ||
          typeof value === "string" ||
          (value instanceof File &&
            ["image/jpeg", "image/png", "image/jpg"].includes(value.type))
      )
      .test(
        "fileSize",
        "Image size must be ≤ 1MB",
        (value) =>
          !value ||
          typeof value === "string" ||
          (value instanceof File && value.size <= 1024 * 1024)
      ),

    a_title: yup
      .string()
      .trim()
      .required("Title is required")
      .max(150, "Title must be at most 150 characters"),

    a_subTitle: yup
      .string()
      .trim()
      .required("Sub Title is required")
      .max(150, "Sub Title must be at most 150 characters"),

    a_ctaText: yup
      .string()
      .trim()
      .required("CTA Text is required")
      .max(50, "CTA Text must be at most 50 characters"),
  }),

  otp: yup.object({
    v_image: yup
      .string()
      .nullable()
      .optional(),

    v_title: yup
      .string()
      .trim()
      .required("Title is required")
      .max(150, "Title must be at most 150 characters"),

    v_ctaText: yup
      .string()
      .trim()
      .required("CTA text is required")
      .max(50, "CTA Text must be at most 50 characters"),

    v_resend_otp_text: yup
      .string()
      .trim()
      .required("Resend OTP text is required")
      .max(50, "Resend OTP text must be at most 50 characters"),

    v_otp_time_text: yup
      .string()
      .trim()
      .required("OTP time text is required")
      .max(50, "OTP time text must be at most 50 characters"),

    v_otp_time: yup
      .number()
      .typeError("OTP time must be a number")
      .required("OTP time is required")
      .integer("OTP time must be in whole seconds")
      .min(1, "OTP time must be at least 1 second")
      .max(59, "OTP time must be less than 60 seconds"),
  }),
});
